const Pending = ({ title, ...props }) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" {...props}>
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <g fillRule="nonzero">
        <path d="M12 3a9 9 0 109 9 9.011 9.011 0 00-9-9z" fill="#FE9526" />
        <path
          d="M11.046 6.6a.9.9 0 01.9.9v4.131l2.44 2.43a.9.9 0 11-1.27 1.269l-2.7-2.7a.9.9 0 01-.27-.63V7.5a.9.9 0 01.9-.9z"
          fill="#FFF"
        />
      </g>
    </g>
  </svg>
);

export default Pending;
